import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { type CalculatorUrlDto, getCalculatorUrls } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useCalculatorsUrls(): UseQueryResult<CalculatorUrlDto, AxiosError> {
    const queryKey = useMemo(() => queryKeys.calculatorsUrls(), []);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getCalculatorUrls({ signal }).then((result) => result.data),
    });
}
